import { toTitleCase } from "../../../../Utils/stringUtls";
import React from "react";
const AutomatedClearingHouse = ({ data }) => {
  const {
    ov_ach_account,
    ov_ach_bank,
    ov_ach_odfi,
    ov_ach_routing,
    ov_ach_use_odfi,
  } = data["6_7"];
  return ov_ach_use_odfi?.length ? (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md">
          <div className="fw-700 review-summary-sub-heading font-bold">
            Automated Clearing House Facility – ACH
          </div>
          <div className="overview-help-text-for-heading font-bold review-summary-sub-heading">
            Would you like to use i2c Inc's default ODFI Institute/Services?
          </div>
          <div className="overview-val-text">
            {toTitleCase(ov_ach_use_odfi)}
          </div>
        </div>

        {ov_ach_use_odfi === "no" ? (
          <React.Fragment>
            {" "}
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">ODFI institute</div>
              <div className="overview-val-text">
                {ov_ach_odfi?.length ? ov_ach_odfi : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">
                Settlement Bank
              </div>
              <div className="overview-val-text">
                {ov_ach_bank?.length ? ov_ach_bank : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">
                Settlement Account
              </div>
              <div className="overview-val-text">
                {ov_ach_account?.length ? ov_ach_account : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">
                Settlement Routing #
              </div>
              <div className="overview-val-text">
                {ov_ach_routing?.length ? ov_ach_routing : "-"}
              </div>
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    </div>
  ) : null;
};
export default AutomatedClearingHouse;
